import { DateTime } from "luxon";
import { NEUTRAL, STATUS_BADGE, SURFACE } from "../../theme/tokens";

export const TABLE_HEADERS = [
	{ field: "#" as const, label: "#", sortable: false, width: "50px" },
	{ field: "nurseName" as const, label: "Name", sortable: true, width: "15%" },
	{ field: "role" as const, label: "Role", sortable: true, width: "8%" },
	{ field: "employmentType" as const, label: "Employment Type", sortable: true, width: "12%" },
	{ field: "startTime" as const, label: "Start Time", sortable: true, width: "18%" },
	{ field: "endTime" as const, label: "End Time", sortable: true, width: "18%" },
	{ field: "location" as const, label: "Location", sortable: true, width: "12%" },
	{ field: "agencyName" as const, label: "Agency", sortable: true, width: "10%" },
	{ field: "charge" as const, label: "Charge", sortable: true, width: "7%" },
] as const;

export const CSV_HEADERS = ["#", "Name", "Role", "Employment Type", "Start Time", "End Time", "Location", "Agency", "Charge"];

export const PAGE_SIZE = 50;

export const TABLE_STYLES = {
	container: {
		flex: 1,
		overflow: "auto" as const,
		"&::-webkit-scrollbar": {
			width: "6px",
			height: "6px",
		},
		"&::-webkit-scrollbar-track": {
			background: NEUTRAL[100],
			borderRadius: "3px",
		},
		"&::-webkit-scrollbar-thumb": {
			background: NEUTRAL[500],
			borderRadius: "3px",
		},
		"&::-webkit-scrollbar-thumb:hover": {
			background: NEUTRAL[600],
		},
	},
	table: {
		tableLayout: "fixed" as const,
		width: "100%",
		"& .MuiTableCell-root": {
			boxSizing: "border-box",
			padding: "10px",
			whiteSpace: "nowrap" as const,
			overflow: "hidden",
			textOverflow: "ellipsis",
			textAlign: "center" as const,
		},
		"& thead th": {
			height: "36px",
			background: "var(--inhouse-primary-alpha-16)",
			borderBottom: `1px solid ${NEUTRAL[200]}`,
			color: STATUS_BADGE.BRAND_FALLBACK,
			fontSize: "0.875rem",
			fontWeight: "bold",
			padding: "13px 10px",
			textAlign: "center" as const,
			position: "sticky" as const,
			top: 0,
			zIndex: 1,
		},
		"& tbody td": {
			height: "36px",
			background: SURFACE,
			borderBottom: `1px solid ${NEUTRAL[200]}`,
			color: STATUS_BADGE.BRAND_FALLBACK,
			fontSize: "0.875rem",
			textAlign: "center" as const,
			padding: "6px 10px",
		},
	},
};

export const getInitialDateRange = () => {
	const today = DateTime.now();
	return {
		from: today.minus({ months: 3 }).startOf("day"),
		to: today.endOf("day"),
	};
};
